var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/modules/_core.js
// module id = 11
// module chunks = 169